import React, { Component } from "react";
import { Button, Icon, Modal, Loader, Dimmer } from "semantic-ui-react";
import Select from "components/Form/Select";
import { Field, Formik, Form } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import ViewFilesModal from "features/FolderManager/components/modals/ViewFilesModal";
import moment from "moment";
import { toast } from "../../../../../node_modules/react-toastify/dist/index";

const schemaValidation = Yup.object().shape({
	prescription: Yup.number().required("Champ requis"),
});

class AddRepeatablePrescriptionModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: false,
			prescription: null,
			scanPrescriptionViewOpen: false,
			base64Pdf: "",
		};
	}

	showScans = async (prescriptionId) => {
		const res = await this.props.getMyLabDocuments(prescriptionId);
		if (res.payload.data?.base64) {
			if (res.payload.data.base64.status) toast.warn("Le document de l'ordonnance renouvelable est introuvable.");
			else this.setState({ base64Pdf: res.payload.data.base64, scanPrescriptionViewOpen: true });
		}
	};

	hasScan = (prescriptionId) => {
		const prescriptions = this.props.prescriptions.repeatable.list;
		const prescription = prescriptions.find((prescri) => prescri.id === prescriptionId);

		return prescription?.scans.length > 0;
	};

	render() {
		const { open, prescriptions, close } = this.props;
		const { loading, prescription, scanPrescriptionViewOpen, base64Pdf } = this.state;
		return (
			<Modal size="small" open={open} closeOnEscape closeOnDimmerClick onClose={close}>
				<Modal.Header>
					{prescriptions.repeatable && prescriptions.repeatable.list && prescriptions.repeatable.list.length > 0
						? "Il existe des prescriptions renouvelables enregistrées pour ce patient"
						: "Prescription renouvelable"}
				</Modal.Header>
				<Formik
					enableReinitialize
					initialValues={{
						prescription: null,
					}}
					validationSchema={schemaValidation}
					onSubmit={async (values) => {
						this.setState({ loading: true });
						await this.props.submit(values);
						this.setState({ loading: false });
						close(false);
					}}
				>
					{({ submitForm, values }) => (
						<>
							<Modal.Content>
								{loading ? (
									<Dimmer active>
										<Loader size="large">Loading</Loader>
									</Dimmer>
								) : prescriptions.repeatable && prescriptions.repeatable.list && prescriptions.repeatable.list.length > 0 ? (
									<Form>
										<div>Voulez-vous utiliser une prescription renouvelable ? </div>

										<Field
											component={Select}
											name="prescription"
											customlabel="Prescription"
											placeholder="Sélectionner une prescription"
											options={prescriptions.repeatable.list.map((prescription) => {
												return {
													value: prescription.id,
													label: `${prescription.prescriber?.title} ${prescription.prescriber?.last_name} ${
														prescription.prescriber?.first_name
													} - ${moment(prescription.issue_date).format(process.env.REACT_APP_DATE_DISPLAY_FORMAT)} - ${moment(
														prescription.validity_date
													).format(process.env.REACT_APP_DATE_DISPLAY_FORMAT)} - ${moment(prescription.lastRepetition).format(
														process.env.REACT_APP_DATE_DISPLAY_FORMAT
													)} - ${prescription.analyses.map((a) => a.properties.code).join(",")}
														- Utilisation(s): ${prescription.repetitionCount - prescription.repetitionCountCanceled}`,
												};
											})}
											required
										/>
										<span style={{ fontSize: 12, fontStyle: "italic" }}>
											NB: Les informations de la liste déroulante sont "Prescripteur - Date de délivrance - Date de validité - Date de dernière
											utilisation - Analyses - nombre d'utilisations"
										</span>
									</Form>
								) : (
									<div>Pas de prescription renouvelable trouvée pour ce patient</div>
								)}
							</Modal.Content>

							<Modal.Actions>
								{prescriptions.repeatable && prescriptions.repeatable.list && prescriptions.repeatable.list.length > 0 && (
									<>
										<Button color="blue" onClick={() => this.showScans(values.prescription)} inverted disabled={!this.hasScan(values.prescription)}>
											<Icon name="file outline" /> Voir la prescription
										</Button>
										<Button
											onClick={(e) => {
												if (e !== undefined) e.preventDefault();
												close();
											}}
										>
											<Icon name="remove" /> Non
										</Button>
										<Button
											primary
											disabled={!values.prescription}
											onClick={(e) => {
												if (e !== undefined) e.preventDefault();
												submitForm();
											}}
										>
											<Icon name="folder open outline" /> Utiliser
										</Button>
									</>
								)}
								{prescriptions.repeatable && prescriptions.repeatable.list && prescriptions.repeatable.list.length === 0 && (
									<Button
										onClick={(e) => {
											if (e !== undefined) e.preventDefault();
											close();
										}}
									>
										<Icon name="close" /> Fermer
									</Button>
								)}
							</Modal.Actions>
						</>
					)}
				</Formik>
				<ViewFilesModal
					open={scanPrescriptionViewOpen}
					close={() => this.setState({ scanPrescriptionViewOpen: false, base64Pdf: "" })}
					files={prescription?.scans}
					base64Pdf={base64Pdf}
					telesec={false}
				/>
			</Modal>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		prescriptions: state.prescriptions,
	};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AddRepeatablePrescriptionModal);
